import React from 'react'

import { Typography } from '~/components/elements/Typography'

import { type BrandAccount } from '../hooks/useMainQuery'

export type NameCellProps = {
  dataItem: BrandAccount
}

export const NameCell = ({ dataItem: brandAccount }: NameCellProps) => (
  <td>
    <Typography fontSize={14} variant="normal">
      {brandAccount.name}
    </Typography>
  </td>
)
